import { atomWithQuery } from 'jotai-tanstack-query'
import type { MediaAppearance } from '@/payload-types'
import { sdk } from '../../../payload'
import { getQueryClient } from '../queryClient'

export const latestMediaAppearances = atomWithQuery<MediaAppearance[]>(
	() => ({
		queryKey: ['latestMediaAppearances:home', { limit: 10 }],
		staleTime: 60_000,
		gcTime: 5 * 60_000,
		queryFn: async () => {
			const res = await sdk.find({
				collection: 'media-appearances',
				limit: 5,
				sort: '-date',
			})
			return res?.docs
		},
	}),
	getQueryClient,
)
